import React, { useState } from 'react'
import './QuotesPopup.css'

interface Quote {
  quoteId: number
  ref: number
  refFormatted: string
}

interface QuotesPopupProps {
  quotes: Quote[]
  triggerText?: string
  className?: string
}

const QuotesPopup: React.FC<QuotesPopupProps> = ({ 
  quotes, 
  triggerText = 'View Quotes',
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleQuoteClick = (quoteId: number, event: React.MouseEvent) => {
    event.stopPropagation()
    window.open(`/quotes/?id=${quoteId}`, '_blank')
  }

  if (!quotes || quotes.length === 0) {
    return null
  }

  return (
    <div 
      className={`quotes-popup-container ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <span className="quotes-popup-trigger">
        {triggerText} ({quotes.length})
      </span>
      
      {isVisible && (
        <div className="quotes-popup-content">
          <div className="quotes-popup-header">
            Associated Quotes
          </div>
          <div className="quotes-popup-list">
            {quotes.map((quote) => (
              <div 
                key={quote.quoteId}
                className="quotes-popup-item"
                onClick={(e) => handleQuoteClick(quote.quoteId, e)}
                title={`Click to view Quote ${quote.refFormatted}`}
              >
                <span className="quote-ref">{quote.refFormatted}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default QuotesPopup
